var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = !_vm.loadding ? _vm.theme() : null
  var m1 = !_vm.loadding ? _vm.theme() : null
  var m2 =
    !_vm.loadding && _vm.detail.points_money > 0 ? _vm.points_name() : null
  var g0 =
    !_vm.loadding && _vm.detail.order_source == 70
      ? (_vm.detail.pay_price * 1 + _vm.detail.advance.pay_price * 1).toFixed(2)
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        g0: g0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }